// @ts-nocheck -- RARE-264 mechanical rename; type this file under RARE-265
import PropTypes from "prop-types";
import Level from "./Level";

const Levels = ({ visible, ...props }) => {
  if (!visible) {
    return <></>;
  }
  return (
    <div className={"segment-multilevel-leaves"}>
      <Level {...props} level={0} />
    </div>
  );
};

Levels.propTypes = {
  items: PropTypes.array.isRequired,
  selected: PropTypes.any,
  onChange: PropTypes.func,
  visible: PropTypes.bool,
};

export default Levels;
